export default __webpack_public_path__ + "static/media/user.2e7d903f.svg";